// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"453":"533ece5d","785":"f608e288"}[chunkId] + ".chunk.js";
};